import { authApi } from "./auth";
import { mainServiceURL } from "./defines";

export const productsApi = authApi.injectEndpoints({
  endpoints: (builder) => ({
    getProduct: builder.query({
      query: (id: string) => ({
        url: mainServiceURL + `/products/${id}`,
      }),
      providesTags: ["Products"],
    }),
    getProductByType: builder.query({
      query: (type: string) => ({
        url: mainServiceURL + `/products/type/${type}`,
      }),
      providesTags: ["Products"],
    }),
  }),
});

export const { useGetProductQuery, useGetProductByTypeQuery } = productsApi;
